module.exports = __webpack_public_path__ + "static/media/icons8-vue-js.b00020dd.svg";